import HomeView from './views/home'
import NotFoundView from './views/not-found'
import ProfileView from './views/profile'
import OrderView from './views/ordering'
import AboutView from './views/about'
import ContactsView from './views/contacts'

export const routes = [
  ...HomeView,
  ...NotFoundView,
  ...ProfileView,
  ...OrderView,
  ...AboutView,
  ...ContactsView,
]
